import { useContext, useEffect } from 'react'

import { digObject } from '@domain-group/javascript-utils'

import {
  Button, Form, ModalContext, SidebarModal, SidebarModalListItem,
} from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useMessageBookingContactsModal from './hooks/useMessageBookingContactsModal'

const MODAL_KEY = 'MessageBookingContactsModal'

export type ModalCallbacks = {
  closeModal: () => void,
  sendUnapprovedArtworkMessage: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const MessageBookingContactsModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { sendUnapprovedArtworkMessage } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { publicationBooking: initPublicationBooking } = modalPayload

  const messageBookingContactsPayload = useMessageBookingContactsModal({
    callbacks,
    publicationBooking: initPublicationBooking,
  })

  const {
    callbacks: {
      deselectContact,
      loadContacts,
      setDefaultMessage,
      setState,
    },
    contacts,
    loading,
    message,
    publicationBookingPayload,
    saveEnabled,
    sendUnapprovedArtworkMessagePayload,
  } = messageBookingContactsPayload

  const {
    publicationBooking,
    updating,
  } = publicationBookingPayload

  useEffect(() => {
    if (publicationBooking.id){
      loadContacts()
      setDefaultMessage()
    }
  }, [publicationBooking.id])

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Message" titleSecondLine="Booking Contacts" />

      <SidebarModal.Content>
        <Form.Field label="Recipients" labelProps={{ marginBottom: 0 }}>
          {!loading && (
            Object.values(contacts).map((contact) => {
              const { full_name, email, mobile_number } = contact

              return (
                <SidebarModalListItem
                  // @ts-expect-error TS2339
                  key={contact.user_id}
                  childrenHolderProps={{ alignItems: 'center' }}
                  secondaryText={email}
                  title={full_name}
                >
                  {/*
                   // @ts-expect-error TS2339 */}
                  <SidebarModalListItem.TertiaryText>
                    {mobile_number}
                    {/*
                   // @ts-expect-error TS2339 */}
                  </SidebarModalListItem.TertiaryText>

                  {/*
                   // @ts-expect-error TS2339 */}
                  <SidebarModalListItem.Actions>
                    {/*
                     // @ts-expect-error TS2339 */}
                    <SidebarModalListItem.Icon
                      disabled={contacts.length === 1}
                      onClick={() => deselectContact(contact)}
                      boxProps={{ marginLeft: 'medium' }}
                      type="delete"
                    />
                    {/*
                   // @ts-expect-error TS2339 */}
                  </SidebarModalListItem.Actions>
                </SidebarModalListItem>
              )
            })
          )}
        </Form.Field>

        <Form.Field
          direction="column"
          label="Message"
        >
          <textarea
            onChange={e => setState({ message: e.target.value })}
            style={{ minHeight: 200, resize: 'vertical' }}
            value={message}
          />
        </Form.Field>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={updating}
          // @ts-expect-error TS2345
          onClick={() => sendUnapprovedArtworkMessage(sendUnapprovedArtworkMessagePayload)}
          size="large"
        >
          {saveEnabled ? 'Send Message' : 'No Booking Contacts'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <MessageBookingContactsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
